import { render } from "./IssuanceQuestions.vue?vue&type=template&id=89fb7356&scoped=true"
import script from "./IssuanceQuestions.vue?vue&type=script&lang=js"
export * from "./IssuanceQuestions.vue?vue&type=script&lang=js"

import "./IssuanceQuestions.vue?vue&type=style&index=0&id=89fb7356&lang=css"
import "./IssuanceQuestions.vue?vue&type=style&index=1&id=89fb7356&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89fb7356"]])

export default __exports__